import { c as _c } from "react/compiler-runtime";
import { LoadingOutlined } from '@ant-design/icons';
import { Spin, type SpinProps } from 'antd';
import type { FC } from 'react';
import { SpinContainer } from './Spinner.style';
type Props = {
  size?: SpinProps['size'];
  alternate?: boolean;
};
const Spinner: FC<Props> = t0 => {
  const $ = _c(5);
  const {
    size: t1,
    alternate: t2
  } = t0;
  const size = t1 === undefined ? "medium" : t1;
  const alternate = t2 === undefined ? false : t2;
  let t3;
  if ($[0] !== alternate) {
    t3 = alternate ? {
      indicator: <LoadingOutlined style={{
        fontSize: 24
      }} spin={true} />
    } : {};
    $[0] = alternate;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== size || $[3] !== t3) {
    t4 = <SpinContainer aria-label="Loading" data-testid="loading-spinner"><Spin size={size} {...t3} /></SpinContainer>;
    $[2] = size;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};
export default Spinner;